import { Box, styled } from '@mui/material';
import { spaceCadet, ultraMarine } from '../../../../../utils/colors';

const StyledBox = styled(Box)({
  width: '100%',
  flexGrow: 1,
  minHeight: 0,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',

  '& > .MuiBox-root.header': {
    padding: '14px 16px 10px',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    '& > .MuiTypography-h2': {
      color: spaceCadet[500],
      fontWeight: 700,
      fontSize: 14,
      lineHeight: '20px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      flexShrink: 1,
      minWidth: 0,
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      '& svg': {
        fontSize: 16,
        display: 'block',
        color: ultraMarine[500],
        flexShrink: 0,
      },
    },
  },

  '& > .MuiBox-root.content': {
    backgroundColor: spaceCadet[100],
    borderTop: `1px solid ${spaceCadet[100]}`,
    padding: 8,
    overflowY: 'auto',
    flexGrow: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
  },
});

export default StyledBox;
